import { render } from "./globalMenuBar.vue?vue&type=template&id=0ca3024e&scoped=true"
import script from "./globalMenuBar.vue?vue&type=script&lang=js"
export * from "./globalMenuBar.vue?vue&type=script&lang=js"

import "./globalMenuBar.vue?vue&type=style&index=0&id=0ca3024e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca3024e"]])

export default __exports__